import {
    REQUEST_EVENTS,
    RECEIVE_EVENTS,
    UPDATE_EVENTS,
    ERROR_EVENTS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem, reloadDashboard} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters"

function request() {
    return {
        type: REQUEST_EVENTS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_EVENTS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_EVENTS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_EVENTS,
        id,
        payload: data,
        updateType
    }
}

export function getEvents(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().events, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'events',
                params: prepareFilters(params, getState(), "events")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getEvent(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('event'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'events/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createEvent(data, fromSelect = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            if(!fromSelect){
                dispatch(requestItem())
            }
            return axios({
                method: 'POST',
                url: fetchUrl + 'events',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateEvent(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('event'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'events/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadDashboard('events'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteEvent(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'events/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadDashboard())
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}